import React, { FC } from 'react';

import { useGamePolling } from '@nhl/react-hooks/lib/useGamePolling';

import { useGameCenterBoxscoreQuery, useGameCenterRightRailQuery } from '../../api';
import TeamRoster from '../../components/teamRoster/TeamRoster';
import { GameCenterViewType } from '../../enums';
import GameCenterLoader from '../gameCenterLoader/GameCenterLoader';
import RightRail from '../rightRail/RightRail';

import { BoxscoreContainer } from './styles';

type Props = {
    gameId?: number;
};

const Boxscore: FC<Props> = ({ gameId }) => {
    const { data: game, isInitialLoad, refetch } = useGameCenterBoxscoreQuery(gameId);
    useGamePolling(refetch, [game]);

    const { refetch: refetchRightRail } = useGameCenterRightRailQuery(gameId);
    useGamePolling(refetchRightRail, [game]);

    return (
        <BoxscoreContainer
            id={`${GameCenterViewType.BOXSCORE}-tabpanel`}
            role="tabpanel"
            aria-labelledby={GameCenterViewType.BOXSCORE}
            $details={game.summary}
        >
            <GameCenterLoader isInitialLoad={isInitialLoad}>
                <TeamRoster game={game} playerByGameStats={game.playerByGameStats} />
            </GameCenterLoader>
            <RightRail />
        </BoxscoreContainer>
    );
};

export default Boxscore;
